import { AppHeader } from "@/components/AppHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PlayersTab } from "@/pages/admin/PlayersTab";
import { SyncTab } from "@/pages/admin/SyncTab";
import { MembersTab } from "@/pages/admin/MembersTab";
import { CoverageTab } from "@/pages/admin/CoverageTab";
import { AccessRequestsTab } from "@/pages/admin/AccessRequestsTab";
import { RosterTab } from "@/pages/admin/RosterTab";
import { RugbyTab } from "@/pages/admin/RugbyTab";
import { DataTransferTab } from "@/pages/admin/DataTransferTab";
import { MatchAnalysisTab } from "@/pages/admin/MatchAnalysisTab";
import { PrototypesTab } from "@/pages/admin/PrototypesTab";

const roster = (sport) => () => <RosterTab sport={sport} />;

const TABS = [["players", "Players", PlayersTab], ["sync", "Data sync", SyncTab], ["coverage", "FanFlare coverage", CoverageTab], ["softball", "Softball rosters", roster("softball")], ["basketball", "Basketball rosters", roster("basketball")], ["lacrosse", "Lacrosse rosters", roster("lacrosse")], ["beach", "Beach volleyball rosters", roster("beach")], ["rugby", "Rugby rosters", RugbyTab], ["requests", "Access requests", AccessRequestsTab], ["members", "Members", MembersTab], ["transfer", "Data transfer", DataTransferTab], ["match", "Match analysis", MatchAnalysisTab], ["prototypes", "Prototypes", PrototypesTab]];

export default function AdminPage() {
  return (
    <div className="min-h-screen bg-[#0B0F19]">
      <AppHeader />
      <main className="mx-auto max-w-[1400px] px-4 pb-24 pt-10 sm:px-8">
        <p className="eyebrow !text-[#FF2D78]">Admin panel</p>
        <h1 className="mt-3 font-display text-4xl font-black uppercase tracking-tight sm:text-5xl">Control room</h1>
        <Tabs defaultValue="players" className="mt-10">
          <TabsList className="h-auto flex-wrap justify-start gap-1 border border-slate-800 bg-[#131927] p-1">
            {TABS.map(([v, l]) => (
              <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`}
                className="px-4 py-2 font-data text-[11px] uppercase tracking-wider data-[state=active]:bg-[#FF2D78] data-[state=active]:text-white">
                {l}
              </TabsTrigger>
            ))}
          </TabsList>
          {TABS.map(([v, , C]) => <TabsContent key={v} value={v} className="mt-8"><C /></TabsContent>)}
        </Tabs>
      </main>
    </div>
  );
}
